export default "__VITE_ASSET__CUSD1rNJ__"